import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;

export const addDesignRate = async (token, data) => {
  const url = `${BASE_URL}/ratediary/rate-diary/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500
      ) {
        console.log("Client Error:", error.response);
        return error.response;
      } else {
        console.error("Server or Network Error:", error);
        throw error;
      }
  }
};

export const getAllDesignRates = async (token, params = {}) => {
  const url = `${BASE_URL}/ratediary/rate-diary/`;

  // console.log(url, params);
  

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
    params,
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getDesignRate = async (token, designRateId) => {
  const url = `${BASE_URL}/ratediary/rate-diary/${designRateId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const updateDesignRate = async (token, data, designRateId) => {
  const url = `${BASE_URL}/ratediary/rate-diary/${designRateId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.patch(url, data, config);
    return response;
  } catch (error) {
    if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500
      ) {
        console.log("Client Error:", error.response);
        return error.response;
      } else {
        console.error("Server or Network Error:", error);
        throw error;
      }
  }
};

export const deleteDesignRate = async (token, designRateId) => {
  const url = `${BASE_URL}/ratediary/rate-diary/${designRateId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500
      ) {
        console.log("Client Error:", error.response);
        return error.response;
      } else {
        console.error("Server or Network Error:", error);
        throw error;
      }
  }
};
